import * as React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  border: 1px solid #dadada;
  background: #eee;

  border-radius: 5px;

  margin-bottom: 5px;
  margin-right: 5px;

  width: fit-content;
  display: inline-block;

  > .tag-content {
    padding: 0 8px;
  }

  > button {
    background: #ccc;
    border: none;
  }
`;

export interface ITagOwnProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode;
  onCloseClick?: (event: React.MouseEvent<Element>) => void;
}

export const Tag = ({ children, onCloseClick, ...props }: ITagOwnProps) => (
  <StyledWrapper {...props as any}>
    <span className="tag-content">
      {children}
    </span>

    {onCloseClick ? <button onClick={onCloseClick}>&times;</button> : null}
  </StyledWrapper>
);
